export default "__VITE_ASSET__XCf30Luw__"